let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hhss7"), load("kSVGa")]).then(() => parcelRequire('5BDEU'));